export default "__VITE_ASSET__CMFR4F2f__"